<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>个人资料</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="personal_data_box">
      <div class="personal_data_pic">
        <el-upload
          class="personal_data_pic_uploader"
          action="Fask"
          :show-file-list="false"
          :http-request="UploadImage"
          :before-upload="beforeAvatarUpload">
          <img :src="info.portrait">
          <el-button size="small" type="primary" class="personal_data_pic_uploader_btn">点击上传</el-button>
        </el-upload>
      </div>
      <div class="personal_data_item personal_data_padding_left" @mouseenter="editOnOff.user_name = true" @mouseleave="editOnOff.user_name = false">
        <p class="personal_data_label">用户名: </p>
        <div class="personal_data_input">
          <div v-show="onoff.user_name">
            <el-input v-model="info.user_name" placeholder="请输入内容"></el-input>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('user_name')">保存</el-button>
              <el-button plain @click="onoff.user_name = false">取消</el-button>
            </div>
          </div>
          <div v-show="!onoff.user_name">
            <span class="personal_data_text">{{info.user_name}}</span>
            <el-button v-show="editOnOff.user_name" type="text" class="personal_data_text_edit" @click="onoff.user_name = true">修改<i class="el-icon-edit"></i></el-button>
          </div>
        </div>
      </div>
      <div class="personal_data_item personal_data_padding_left" @mouseenter="editOnOff.sex = true" @mouseleave="editOnOff.sex = false">
        <p class="personal_data_label">性别: </p>
        <div class="personal_data_input">
          <div v-show="onoff.sex">
            <el-radio v-model="info.sex" label="男">男</el-radio>
            <el-radio v-model="info.sex" label="女">女</el-radio>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('sex')">保存</el-button>
              <el-button plain @click="onoff.sex = false">取消</el-button>
            </div>
          </div>
          <div v-show="!onoff.sex">
            <span class="personal_data_text">{{info.sex}}</span>
            <el-button v-show="editOnOff.sex" type="text" class="personal_data_text_edit" @click.stop="onoff.sex = true">修改<i class="el-icon-edit"></i></el-button>
          </div>
        </div>
      </div>
      <div class="personal_data_item personal_data_padding_left" @mouseenter="editOnOff.content = true" @mouseleave="editOnOff.content = false">
        <p class="personal_data_label">简介: </p>
        <div class="personal_data_input">
          <div v-show="onoff.content">
            <el-input type="textarea" placeholder="请输入简介" v-model="info.content"></el-input>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('content')">保存</el-button>
              <el-button plain @click.stop="onoff.content = false">取消</el-button>
            </div>
          </div>
          <div v-show="!onoff.content">
            <span class="personal_data_text">{{info.content}}</span>
            <el-button v-show="editOnOff.content" type="text" class="personal_data_text_edit" @click.stop="onoff.content = true">修改<i class="el-icon-edit"></i></el-button>
          </div>
        </div>
      </div>
      <!-- 居住地 -->
      <div class="personal_data_item" @mouseenter="editOnOff.place_of_residence = true" @mouseleave="editOnOff.place_of_residence = false">
        <p class="personal_data_label">居住地: </p>
        <div class="personal_data_input">
          <div v-show="onoff.place_of_residence">
            <el-col>
              <area-view @area="area"></area-view>
            </el-col>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('place_of_residence')">保存</el-button>
              <el-button plain @click.stop="onoff.place_of_residence = false">取消</el-button>
            </div>
          </div>
          <div v-show="!onoff.place_of_residence">
            <span v-if="info.province !== ''" class="personal_data_text">
              <i v-if="info.province !== ''">{{info.province}} - </i>
              <i v-if="info.city !== ''">{{info.city}}</i>
              <i v-if="info.area !== ''"> - {{info.area}}</i>
            </span>
            <el-button v-show="editOnOff.place_of_residence" type="text" class="personal_data_text_edit" @click.stop="onoff.place_of_residence = true">修改<i class="el-icon-edit"></i></el-button>
          </div>
        </div>
      </div>
      <!-- 所在行业 -->
      <div class="personal_data_item" @mouseenter="editOnOff.industry = true" @mouseleave="editOnOff.industry = false">
        <p class="personal_data_label">所在行业: </p>
        <div class="personal_data_input">
          <div v-show="onoff.industry">
            <el-select v-model="info.industry" placeholder="请选择">
                <el-option
                  v-for="item in industryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id + ''">
                </el-option>
              </el-select>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('industry')">保存</el-button>
              <el-button plain @click.stop="onoff.industry = false">取消</el-button>
            </div>
          </div>
          <div v-show="!onoff.industry">
            <span class="personal_data_text">{{info.industryName}}</span>
            <el-button v-show="editOnOff.industry" type="text" class="personal_data_text_edit" @click.stop="onoff.industry = true">修改<i class="el-icon-edit"></i></el-button>
          </div>
        </div>
      </div>
      <!-- 职业经历 -->
      <div class="personal_data_item" @mouseenter="editOnOff.professional_experience = true" @mouseleave="editOnOff.professional_experience = false">
        <p class="personal_data_label">职业经历: </p>
        <div class="personal_data_input">
          <el-button type="text"
          class="personal_data_add_btn"
          @click.stop="onoff.professional_experience = true; professional.company = ''; professional.position = ''">
            + 添加职业经历
          </el-button>
          <div v-show="onoff.professional_experience">
            <el-row :gutter="20">
              <el-col :span="9">
                <el-input v-model="professional.company" placeholder="请输入公司"></el-input>
              </el-col>
              <el-col :span="9">
                <el-input v-model="professional.position" placeholder="请输入职位"></el-input>
              </el-col>
            </el-row>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('professional_experience')">保存</el-button>
              <el-button plain @click.stop="onoff.professional_experience = false">取消</el-button>
            </div>
          </div>
          <ul v-if="info.professional_experience.length > 0">
            <li v-for="(item, index) in info.professional_experience" :key="item.id" @mouseenter="onoff.professional_del = true" @mouseleave="onoff.professional_del = false">
              {{item.company}} - {{item.position}}
              <el-button v-show="onoff.professional_del" type="text" class="personal_data_text_edit" @click.stop="subDel('professional', index)"><i class="el-icon-close"></i></el-button>
            </li>
          </ul>
        </div>
      </div>
      <!-- 教育经历 -->
      <div class="personal_data_item" @mouseenter="editOnOff.educational_experience = true" @mouseleave="editOnOff.educational_experience = false">
        <p class="personal_data_label">教育经历: </p>
        <div class="personal_data_input">
          <el-button type="text"
          class="personal_data_add_btn"
          @click.stop="onoff.educational_experience = true; educational.start = ''; educational.school = ''; educational.major = ''">
            + 添加教育经历
          </el-button>
          <div v-show="onoff.educational_experience">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-date-picker
                  v-model="educational.start"
                  value-format='yyyy'
                  type="year"
                  placeholder="选择开始年份">
                </el-date-picker>
              </el-col>
              <el-col :span="6">
                <el-date-picker
                  v-model="educational.end"
                  value-format='yyyy'
                  type="year"
                  placeholder="选择结束年份">
                </el-date-picker>
              </el-col>
              <el-col :span="6">
                <el-input v-model="educational.education" placeholder="请输入学历"></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 20px;">
              <el-col :span="6">
                <el-input v-model="educational.school" placeholder="请输入学校"></el-input>
              </el-col>
              <el-col :span="6">
                <el-input v-model="educational.major" placeholder="请输入专业"></el-input>
              </el-col>
            </el-row>
            <div class="personal_data_submit">
              <el-button type="primary" @click="subBtn('educational_experience')">保存</el-button>
              <el-button plain @click.stop="onoff.educational_experience = false">取消</el-button>
            </div>
          </div>
          <ul v-if="info.educational_experience.length > 0">
            <li v-for="(item, index) in info.educational_experience" :key="item.id" @mouseenter="onoff.educational_del = true" @mouseleave="onoff.educational_del = false">
              {{item.start}} 年 ~ {{item.end}} 年 {{item.school}} - {{item.major}} （{{item.education}}）
              <el-button v-show="onoff.educational_del" type="text" class="personal_data_text_edit" @click.stop="subDel('educational', index)"><i class="el-icon-close"></i></el-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import area from '../Public/area.vue'
export default {
  components: {
    areaView: area
  },
  data () {
    return {
      info: {
        portrait: '', // 头像地址
        user_name: '', // 用户名
        nick_name: '',
        sex: '', // 性别
        content: '', // 简介
        place_of_residence: '', // 居住地数组
        province: '', // 居住地-省
        city: '', // 居住地-市
        area: '', // 居住地-县
        industry: 0, // 所在行业ID
        industryName: ' ', // 所在行业名称
        professional_experience: [], // 职业经历
        educational_experience: [] // 教育经历
      },
      professional: { // 职业经历
        company: '', // 公司
        position: '' // 职位
      },
      educational: { // 教育经历
        start: '', // 开始日期
        end: '', // 结束日期
        education: '', // 学历
        school: '', // 学校
        major: '' // 专业
      },
      onoff: { // 是否显示输入框
        pic: false, // 头像按钮显示
        user_name: false,
        sex: false,
        content: false,
        industry: false,
        place_of_residence: false,
        professional_experience: false,
        educational_experience: false,
        professional_del: false,
        educational_del: false
      },
      editOnOff: { // 是否显示修改按钮
        user_name: false,
        sex: false,
        content: false,
        industry: false,
        place_of_residence: false,
        professional_experience: false,
        educational_experience: false
      },
      industryOptions: [],
      placeOptions: []
    }
  },
  created () {
    this.getMyInfo()
  },
  methods: {
    // 获取详情信息
    getMyInfo () {
      const vueThat = this
      vueThat.myApi.getMyDetails().then((res) => {
        if (res.data.code === 200) {
          vueThat.industryOptions = res.data.data.industry
          for (const key in vueThat.info) {
            vueThat.info[key] = parseInt(res.data.data.data[key])
            if (key === 'industryName') {
              if (res.data.data.data.industry === '') {
                vueThat.info.industryName = ''
              } else {
                for (let i = 0; i < res.data.data.industry.length; i++) {
                  if (res.data.data.industry[i].id === parseInt(res.data.data.data.industry)) {
                    vueThat.info.industryName = res.data.data.industry[i].name
                  }
                }
              }
            } else {
              vueThat.info[key] = res.data.data.data[key]
            }
          }
          console.log(vueThat.info)
        }
      })
    },
    // 限制文件类型及大小
    beforeAvatarUpload (file) {
      let fileClass = false
      let fileSize = false
      const fileClassErro = '上传头像只能是 JPG/PNG 格式!'
      const fileSizeErro = '上传头像图片大小不能超过 1MB!'
      this.loading = true
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        fileClass = true
      }
      fileSize = file.size / 1024 / 1024 < 1
      if (!fileClass) {
        this.$message.error(fileClassErro)
      }
      if (!fileSize) {
        this.$message.error(fileSizeErro)
      }
      this.uploadOnOff = fileClass && fileSize
    },
    // 图片上传接口
    async UploadImage (param) {
      const vueThat = this
      if (vueThat.uploadOnOff) {
        const formData = new FormData()
        formData.append('image', param.file)
        try {
          await vueThat.myApi.upload(formData)
            .then(function (res) {
              vueThat.loading = false
              if (res.data.code === 200) {
                vueThat.info.portrait = res.data.data.url
                vueThat.subBtn('portrait')
              }
            })
        } catch (e) {}
      } else {
        vueThat.loading = false
      }
    },
    // 获取居住地
    area (val) {
      this.info.place_of_residence = val
      this.info.province = this.info.place_of_residence[0]
      this.info.city = this.info.place_of_residence[1]
      if (this.info.place_of_residence.length === 3) {
        this.info.area = this.info.place_of_residence[2]
      }
    },
    // 提交按钮
    subBtn (data) {
      const vueThat = this
      let obj
      if (data === 'professional_experience') {
        if (vueThat.professional.company !== '') {
          vueThat.info.professional_experience.push(vueThat.professional)
          obj = {
            [data]: vueThat.info[data]
          }
        } else if (vueThat.professional.company === '' && vueThat.info.professional_experience.length === 0) {
          obj = {
            professional_experience: ''
          }
        } else {
          obj = {
            [data]: vueThat.info[data]
          }
        }
      } else if (data === 'educational_experience') {
        if (vueThat.educational.school !== '') {
          vueThat.info.educational_experience.push(vueThat.educational)
          obj = {
            [data]: vueThat.info[data]
          }
        } else if (vueThat.educational.school === '' && vueThat.info.educational_experience.length === 0) {
          obj = {
            educational_experience: ''
          }
        } else {
          obj = {
            [data]: vueThat.info[data]
          }
        }
      } else if (data === 'place_of_residence') {
        obj = {
          province: vueThat.info.province,
          city: vueThat.info.city,
          area: vueThat.info.area
        }
      } else {
        obj = {
          [data]: vueThat.info[data]
        }
      }
      vueThat.myApi.editPersonalData(obj).then((res) => {
        if (res.data.code === 200) {
          vueThat.$set(vueThat.onoff, data, false)
          if (data === 'user_name' || data === 'portrait') {
            const userInfo = vueThat.$store.state.user.info
            if (data === 'user_name') {
              vueThat.$store.commit('user/updateUserInfo', {
                id: userInfo.id,
                name: vueThat.info.user_name,
                authorization: userInfo.authorization,
                sig: userInfo.sig,
                is_authentication: userInfo.is_authentication,
                portrait: userInfo.portrait
              })
            } else {
              vueThat.$store.commit('user/updateUserInfo', {
                id: userInfo.id,
                name: userInfo.name,
                authorization: userInfo.authorization,
                sig: userInfo.sig,
                is_authentication: userInfo.is_authentication,
                portrait: vueThat.info.portrait
              })
            }
          } else if (data === 'industry') {
            for (let i = 0; i < vueThat.industryOptions.length; i++) {
              if (vueThat.industryOptions[i].id === parseInt(vueThat.info.industry)) {
                vueThat.$set(vueThat.info, 'industryName', vueThat.industryOptions[i].name)
                break
              }
            }
          }
          vueThat.professional = { // 职业经历
            company: '', // 公司
            position: '' // 职位
          }
          vueThat.educational = { // 教育经历
            start: '', // 开始日期
            end: '', // 结束日期
            education: '', // 学历
            school: '', // 学校
            major: '' // 专业
          }
          vueThat.$message({
            message: '修改成功！',
            type: 'success'
          })
        }
      })
    },
    // 删除按钮
    subDel (data, index) {
      if (data === 'educational') {
        this.info.educational_experience.splice(index, 1)
        console.log(this.info.educational_experience)
        this.subBtn('educational_experience')
      } else {
        this.info.professional_experience.splice(index, 1)
        console.log(this.info.professional_experience)
        this.subBtn('professional_experience')
      }
    }
  }
}
</script>

<style scoped="scoped">
  .el-cascader{
    width: 100%;
  }
</style>
